import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})


export class BroadCastService {

  private serverUrl = 'http://localhost:8083/offer';


   // Keep track of the peer connection and tracks
  private peerConnection: RTCPeerConnection | null = null;
  private localStream: MediaStream | null = null;

    async startPublish(localVideo: HTMLVideoElement) {
    // Get local media
    this.localStream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
    localVideo.srcObject = this.localStream;

    // Create PeerConnection
    this.peerConnection = new RTCPeerConnection({
      iceServers: [{ urls: 'stun:stun.l.google.com:19302' }],
    });

    // Add local tracks
    this.localStream.getTracks().forEach(track => this.peerConnection!.addTrack(track, this.localStream!));

    // Handle remote tracks (not needed for publisher, but safe)
    this.peerConnection.ontrack = (event) => {
      console.log('Remote track received', event.streams);
    };

    // Create offer
    const offer = await this.peerConnection.createOffer();
    await this.peerConnection.setLocalDescription(offer);

    // Wait for ICE gathering
    await this.waitForIceGathering();

    // Send SDP to Go server
    const answer = await this.postSdp(this.peerConnection.localDescription!);
    await this.peerConnection.setRemoteDescription(answer);

    console.log('Publishing started');
  }



  async joinBroadcast(remoteVideo: HTMLVideoElement) {
    this.peerConnection = new RTCPeerConnection({
      iceServers: [{ urls: 'stun:stun.l.google.com:19302' }],
    });

    // Receive remote tracks
    this.peerConnection.ontrack = (event) => {
      remoteVideo.srcObject = event.streams[0];
    };

    // Create data channel for SDP (optional, just for handshake)
    const offer = await this.peerConnection.createOffer();
    await this.peerConnection.setLocalDescription(offer);

    await this.waitForIceGathering();

    const answer = await this.postSdp(this.peerConnection.localDescription!);
    await this.peerConnection.setRemoteDescription(answer);

    console.log('Joined broadcast');
  }

   private waitForIceGathering(): Promise<void> {
    return new Promise((resolve) => {
      if (!this.peerConnection) return resolve();
      if (this.peerConnection.iceGatheringState === 'complete') resolve();
      else {
        const checkState = () => {
          if (this.peerConnection!.iceGatheringState === 'complete') {
            this.peerConnection!.removeEventListener('icegatheringstatechange', checkState);
            resolve();
          }
        };
        this.peerConnection.addEventListener('icegatheringstatechange', checkState);
      }
    });
  }







  private async postSdp(description: RTCSessionDescriptionInit): Promise<RTCSessionDescriptionInit> {
    const sdpBase64 = btoa(JSON.stringify(description));

    const res = await fetch(this.serverUrl, {
      method: 'POST',
      body: sdpBase64,
    });

    const answerBase64 = await res.text();
    const answerJson = atob(answerBase64);
    return JSON.parse(answerJson);
  }



}